// Only run if jQuery is loaded
if (typeof $ !== 'undefined' && typeof jQuery !== 'undefined') {
  $(document).ready(() => {
    const STOP_LIST = new Set(['', 'confirmed']);
    const AUTO_HIDE_DELAY = 6000;

  const ensureToastContainer = () => {
    let $container = $('.ds-toast-stack');

    if ($container.length === 0) {
      const $legacyContainer = $('.toast-container');

      if ($legacyContainer.length > 0) {
        $container = $legacyContainer
          .removeClass()
          .addClass('ds-toast-stack')
          .removeAttr('style')
          .attr({ 'aria-live': 'polite', 'aria-atomic': 'true' })
          .appendTo('body');
      } else {
        $container = $('<div/>', {
          class: 'ds-toast-stack',
          'aria-live': 'polite',
          'aria-atomic': 'true'
        }).appendTo('body');
      }
    } else if (!$container.parent().is('body')) {
      $container.appendTo('body');
    }

    return $container;
  };

  const escapeHtml = (unsafeString) =>
    String(unsafeString)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const sanitizeMessage = (message) => {
    if (message === null || message === undefined) return '';

    if (Array.isArray(message)) {
      return message
        .map((item) => sanitizeMessage(item))
        .filter((item) => item.length > 0)
        .join(' ')
        .trim();
    }

    if (typeof message === 'object') {
      return Object.values(message)
        .map((item) => sanitizeMessage(item))
        .filter((item) => item.length > 0)
        .join(' ')
        .trim();
    }

    return String(message).trim();
  };

  const mapTypeToVariant = (type, normalizedMessage) => {
    if (typeof normalizedMessage === 'string' && normalizedMessage.startsWith('Oops')) {
      return 'warning';
    }

    switch (type) {
      case 'notice':
      case 'success':
        return 'success';
      case 'alert':
      case 'warning':
        return 'warning';
      case 'error':
      case 'danger':
        return 'danger';
      default:
        return 'info';
    }
  };

  const createToastContent = (htmlMessage, variant) =>
    `<div class="ds-toast ds-toast--${variant}" role="status" aria-live="polite">
      <div class="ds-toast__body">${htmlMessage}</div>
      <button type="button" class="ds-toast__close" aria-label="Dismiss notification" data-toast-dismiss="true">&times;</button>
    </div>`;

  const showToast = ($toast) => {
    requestAnimationFrame(() => {
      $toast.addClass('is-visible');
    });

    const removeToast = () => {
      $toast.removeClass('is-visible');

      window.setTimeout(() => {
        $toast.remove();
      }, 200);
    };

    const timeoutId = window.setTimeout(removeToast, AUTO_HIDE_DELAY);

    $toast.on('click', '[data-toast-dismiss]', (event) => {
      event.preventDefault();
      window.clearTimeout(timeoutId);
      removeToast();
    });
  };

  const displayToast = (type, message) => {
    const normalizedMessage = sanitizeMessage(message);

    if (STOP_LIST.has(normalizedMessage) || normalizedMessage.length === 0) return;

    const htmlMessage = escapeHtml(normalizedMessage).replace(/\n/g, '<br>');
    const variant = mapTypeToVariant(type, normalizedMessage);
    const $toastContainer = ensureToastContainer();
    const $toast = $(createToastContent(htmlMessage, variant)).appendTo($toastContainer);

    showToast($toast);
  };

  const parseFlashEntries = () => {
    const $flashElement = $('.ds-flash-data, .flash-content');

    if ($flashElement.length === 0) return [];

    if (!$flashElement.parent().is('body')) {
      $flashElement.appendTo('body');
    }

    let content = $flashElement.data('flash') || $flashElement.data('content');

    if (content === undefined || content === null || content === '') return [];

    if (typeof content === 'string') {
      try {
        content = JSON.parse(content);
      } catch (error) {
        console.warn('Unable to parse flash content:', error);
        return [];
      }
    }

    if (Array.isArray(content)) return content;

    if (typeof content === 'object') {
      return Object.entries(content);
    }

    return [];
  };

  // Toast with one action button (e.g. "Undo"). onAction runs at most once;
  // the toast dismisses itself either way.
  const displayActionToast = (type, message, actionLabel, onAction) => {
    const normalizedMessage = sanitizeMessage(message);

    if (normalizedMessage.length === 0) return;

    const htmlMessage = escapeHtml(normalizedMessage).replace(/\n/g, '<br>');
    const variant = mapTypeToVariant(type, normalizedMessage);
    const $toastContainer = ensureToastContainer();
    const $toast = $(
      `<div class="ds-toast ds-toast--${variant}" role="status" aria-live="polite">
        <div class="ds-toast__body">${htmlMessage}</div>
        <button type="button" class="ds-toast__action">${escapeHtml(actionLabel)}</button>
        <button type="button" class="ds-toast__close" aria-label="Dismiss notification" data-toast-dismiss="true">&times;</button>
      </div>`
    ).appendTo($toastContainer);

    $toast.one('click', '.ds-toast__action', (event) => {
      event.preventDefault();
      if (typeof onAction === 'function') onAction();
      $toast.find('[data-toast-dismiss]').trigger('click');
    });

    showToast($toast);
  };

    window.displayToast = displayToast;
    window.displayActionToast = displayActionToast;

    parseFlashEntries().forEach(([type, value]) => displayToast(type, value));
  });
} // End of jQuery check
